import { cva, type VariantProps } from 'class-variance-authority'

export { default as Alert } from './Alert.vue'
export { default as AlertTitle } from './AlertTitle.vue'
export { default as AlertDescription } from './AlertDescription.vue'

export const alertVariants = cva(
    'flex items-start w-full rounded-lg border px-4 py-3 text-sm [&>svg]:shrink-0 [&>svg]:text-foreground [&>svg~*]:pl-2 shadow-sm',
    {
        variants: {
            variant: {
                default: 'bg-background text-foreground',
                destructive:
                    'border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive',
                success:
                    'bg-green-50 text-green-800 border-none dark:border-success [&>svg]:text-green-600',
                error: 'bg-red-50 text-red-800 border-none dark:border-destructive [&>svg]:text-red-500',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    }
)

export type AlertVariants = VariantProps<typeof alertVariants>
